import React, { useCallback } from "react";
import {useDispatch, useSelector} from "react-redux";
import { hideCartCategoryMixAlert } from '../store/actions/checkout.actions';
import { Modal } from './Modal';

function CartCategoryMixAlert() {
    const dispatch = useDispatch();

    const isShow = useSelector(state => state.checkout.isShowCartCategoryMixAlert);
    const category = useSelector(state => state.checkout.categoryMixAlert);
    const specialCategory = useSelector(state => state.cart.specialCategory);

    const handleCloseAlert = useCallback((e) => {
        dispatch(hideCartCategoryMixAlert());
    }, [dispatch]);

    return (
        <Modal title="Attention!" onClose={handleCloseAlert} isOpen={isShow}>
            {specialCategory && (
                <p>{category?.name} items have a specific pickup date. If you wish to order items from other categories, please remove all items related to {category?.name}.</p>
            )}
            {!specialCategory && (
                <p>{category?.name} items have a specific pickup date. If you wish to order items from other categories, please remove all items not related to {category?.name}.</p>
            )}
        </Modal>
    )
}

export default CartCategoryMixAlert;